(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/onboarding-handler/assets/onboarding-theme.js') >= 0) return;  svs.modules.push('/components/accountservices/onboarding-handler/assets/onboarding-theme.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isServer = typeof exports === 'object';
const allowedBrandings = {
  EUROJACKPOT: 'eurojackpot',
  TRISS: 'triss',
  LOTTO: 'lotto',
  KENO: 'keno',
  KENOXPRESS: 'keno',
  VIKINGLOTTO: 'vikinglotto',
  SUPPORTERN: 'supportern',
  LYCKOPLATSEN: 'lyckoplatsen'
};
const inverted = {
  EUROJACKPOT: true,
  TRISS: false,
  LOTTO: true,
  KENO: false,
  VIKINGLOTTO: true,
  SUPPORTERN: true,
  LYCKOPLATSEN: true
};
const accentColor = {
  SUPPORTERN: 'bg-supportern-200',
  TUR: 'bg-tur-200'
};

const getAccentColor = function () {
  var _accentColor$game;
  let game = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'TUR';
  return (_accentColor$game = accentColor[game]) !== null && _accentColor$game !== void 0 ? _accentColor$game : "bg-".concat(game, "-100").toLowerCase();
};

const getInverted = game => {
  var _inverted$game;
  return (_inverted$game = inverted[game]) !== null && _inverted$game !== void 0 ? _inverted$game : false;
};

const getFontColor = isInverted => isInverted ? 'f-inverted' : 'fc-navy';

const getTheme = branding => {
  var _branding$toUpperCase, _allowedBranding$toUp;
  const allowedBranding = allowedBrandings[branding === null || branding === void 0 || (_branding$toUpperCase = branding.toUpperCase) === null || _branding$toUpperCase === void 0 ? void 0 : _branding$toUpperCase.call(branding)];
  const allowedBrandingUpper = allowedBranding === null || allowedBranding === void 0 || (_allowedBranding$toUp = allowedBranding.toUpperCase) === null || _allowedBranding$toUp === void 0 ? void 0 : _allowedBranding$toUp.call(allowedBranding);
  return {
    branding: allowedBranding,
    fontColor: getFontColor(getInverted(allowedBrandingUpper)),
    product: allowedBranding,
    isInverted: getInverted(allowedBrandingUpper),
    accentColor: getAccentColor(allowedBrandingUpper)
  };
};

if (isServer) {
  module.exports = {
    getTheme
  };
} else {
  svs.accountservices.onboardingHandler = _objectSpread(_objectSpread({}, svs.accountservices.onboardingHandler), {}, {
    getTheme
  });
}

 })(window);